import { Icone } from '../../componentes/Icone';
import { useSessao } from '../../chat/contexto';

/** Abrindo o app (A3): conferindo a sessão e esperando o READY; sem servidor, avisa. */
export function Conectando() {
  const { sessao, tentarDeNovo } = useSessao();
  const semServidor = sessao === 'sem-servidor';
  const etapas = [
    { texto: 'Sessão validada', feita: sessao === 'conectando' },
    { texto: 'Canais, permissões e mensagens não lidas', feita: false },
  ];
  return (
    <div className="relative flex h-full items-center justify-center overflow-hidden bg-rail">
      <main
        aria-busy={!semServidor}
        className="flex w-[360px] max-w-full flex-col items-center px-4"
      >
        <span className="flex size-[72px] items-center justify-center rounded-[20px] bg-destaque text-destaque-texto">
          <Icone nome="logo" tamanho={42} />
        </span>
        <h1 className="mt-6 mb-0 text-center text-xl font-semibold">
          {semServidor
            ? 'Sem conexão com o servidor'
            : 'Conectando ao Alternativa Chat'}
        </h1>
        {!semServidor && (
          <>
            <div
              role="progressbar"
              aria-label="Carregando o app"
              className="mt-5 h-1.5 w-[280px] overflow-hidden rounded-[3px] bg-elevado"
            >
              <div
                className="h-1.5 rounded-[3px] bg-destaque transition-[width] duration-500"
                style={{ width: sessao === 'conectando' ? '65%' : '25%' }}
              />
            </div>
            <ul
              aria-label="Etapas da conexão"
              className="mt-7 flex w-[280px] list-none flex-col gap-3 p-0 text-sm"
            >
              {etapas.map((etapa) => (
                <li
                  key={etapa.texto}
                  className={`flex items-center gap-2.5 ${etapa.feita ? 'text-texto-2' : 'font-semibold text-texto'}`}
                >
                  <Icone
                    nome={etapa.feita ? 'check' : 'relogio'}
                    tamanho={18}
                    className={etapa.feita ? 'text-online' : 'text-destaque'}
                  />
                  {etapa.texto}
                </li>
              ))}
            </ul>
          </>
        )}
        {semServidor && (
          <div className="mt-6 flex flex-col items-center gap-4 text-center">
            <p className="m-0 text-[15px] leading-normal text-texto-2">
              Confira a sua internet. Tentamos de novo sozinhos a cada 5
              segundos.
            </p>
            <button
              type="button"
              onClick={tentarDeNovo}
              className="h-9 rounded-lg bg-ativo px-4 text-sm font-semibold hover:brightness-110"
            >
              Tentar agora
            </button>
          </div>
        )}
      </main>
    </div>
  );
}
